// Document Status Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { documentStatusConfig } from './documentStatusConfig';
import { createDocumentStatusValidation } from './documentStatusValidation';
// DocumentStatusService no longer needed - using SWR hooks directly

/**
 * Initialize the document status module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  documentStatusConfig,
  createDocumentStatusValidation
);

/**
 * Create the DocumentStatusPage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const DocumentStatusPage = createModulePage(
  initializedConfig,
  {
    displayName: 'DocumentStatusPage',
    description: 'Document Status Management System - Manage document workflow statuses'
  }
);

export default DocumentStatusPage;
